<template>
	<div class="center-page" v-title title="领券中心">
		<div class="top-box">
			<img class="img" src="@/assets/images/coupon/top_bg.png" alt="" />
		</div>
		<div class="no-more" v-if="!dataList.pendingReceiveList || dataList.pendingReceiveList.length === 0
			">
			<img class="img" src="@/assets/images/coupon/bg_no_more.png" alt="" />
			<span class="tips">抱歉，暂无优惠券呢～</span>
		</div>
		<div class="list" v-else>
			<div class="item" v-for="item in dataList.pendingReceiveList" :key="item.id">
				<img class="img" src="@/assets/images/coupon/coupon_box_bg.png" alt="" />
				<div class="content-info">
					<div class="dot">
						{{ (item.type == 1 && '满减券') || (item.type == 2 && '折扣券') }}
					</div>
					<div class="left">
						<div class="price" v-if="item.type == 1">
							<span style="font-size: 12px">￥</span>
							<span style="font-size: 26px">{{ item.amount }}</span>
						</div>
						<div class="price" v-else-if="item.type == 2">
							<span style="font-size: 26px">{{ item.amount / 10 }}</span>
							<span style="font-size: 12px">折</span>
						</div>
						<div class="condition">满{{ item.minPoint }}元可用</div>
					</div>
					<div class="content">
						<div class="name">{{ item.name }}</div>
						<div class="condition-time">
							<div class="condition">
								{{
			(item.useType == 0 && '全场通用') ||
			(item.useType == 1 && '指定分类可用') ||
			(item.useType == 2 && '指定商品可用')
		}}
							</div>
							<div class="time">
								{{ formatDate(item.startTime, 'yyyy.MM.dd') }} -
								{{ formatDate(item.endTime, 'yyyy.MM.dd') }}
							</div>
						</div>
					</div>
					<div class="right">
						<div class="btn" v-if="item.publishCount - item.receiveCount > 0" @click="receiveCoupon(item.id)">
							立即领取
						</div>
						<img v-else class="img" src="@/assets/images/coupon/icon_none.png" alt="" />
					</div>
				</div>
			</div>
		</div>
		<div class="mine-btn-box">
			<div class="mine-btn" @click="$jump('/couponList')">我的优惠券</div>
		</div>
		<div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/couponCenter"></div>
	</div>
</template>

<script>
import { get } from 'api/get'
import { post } from 'api/post'
import QuanEmpty2 from '@/assets/images/quanEmpty_2.png'

export default {
	name: 'list',
	data() {
		return {
			quanEmpty2: QuanEmpty2,
			value: '',
			active: 1,
			dataList: {
				pendingReceiveList: [
					{
						id: '',
						type: '',
						name: '',
						amount: '',
						minPoint: '',
						startTime: '',
						endTime: '',
						useType: '',
						publishCount: 0,
						receiveCount: 0,
					},
				],
				pendingUseList: [
					{
						coupon: {
							id: '',
							name: '',
							type: '',
							amount: '',
							minPoint: '',
							useType: '',
						},
						categoryRelationList: [],
						productRelationList: [],
					},
				],
			},
		}
	},
	created() {
		this.dataList = []
		this.loadCoupon()

		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	methods: {
		loadCoupon() {
			let self = this
			get('coupon/listUserCoupon').then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.dataList = JSON.parse(JSON.stringify(res.data))
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754a',
					})
				}
			})
		},
		receiveCoupon(id) {
			let self = this
			post('coupon/userReceiveCoupon/' + id).then((res) => {
				console.log(res)
				if (res.code === self.GLOBAL.SUCCESS) {
					self.$toast('领取成功')
					self.loadCoupon()
				} else {
					self.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754a',
					})
				}
			})
		},
		useCoupon(item) {
			console.log('item.coupon.useType : ' + item.coupon.useType)

			if (item.coupon.useType == '0') {
				this.$router.push('/productlsit')
			} else if (item.coupon.useType == '1') {
				let categoryCodeList = item.categoryRelationList.map(
					(i) => i.category3Code
				)
				this.$router.push({
					path: '/productlsit',
					query: { categoryCodeList: JSON.stringify(categoryCodeList) },
				})
			} else if (item.coupon.useType == '2') {
				let productIdList = item.productRelationList.map((i) => i.productId)
				this.$router.push({
					path: '/productlsit',
					query: { productIdList: JSON.stringify(productIdList) },
				})
			}
		},
		formatDate: function (datestr, fmt) {
			let date = new Date(Date.parse(datestr.substring(0, 10)))

			if (/(y+)/.test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1,
					(date.getFullYear() + '').substr(4 - RegExp.$1.length)
				)
			}
			let o = {
				'M+': date.getMonth() + 1,
				'd+': date.getDate(),
				'h+': date.getHours(),
				'm+': date.getMinutes(),
				's+': date.getSeconds(),
			}
			for (let k in o) {
				if (new RegExp(`(${k})`).test(fmt)) {
					let str = o[k] + ''
					fmt = fmt.replace(
						RegExp.$1,
						RegExp.$1.length === 1 ? str : this.padLeftZero(str)
					)
				}
			}
			return fmt
		},
		padLeftZero: function (str) {
			return ('00' + str).substr(str.length)
		},
		onClickLeft() {
			window.history.back()
		},
		onClickRight() { },
	},
}
</script>

<style lang="less" scoped>
/deep/.van-empty__image {
	width: 111px;
	height: 135px;
}

.center-page {
	min-height: 100vh;
	background-color: #f7f7f7;

	.top-box {
		height: 173px;

		.img {
			width: 100%;
			height: 278px;
		}
	}

	.no-more {
		margin-top: 50px;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.img {
			width: 110px;
			height: 100px;
		}

		.tips {
			margin-top: 8px;
			height: 14px;
			font-size: 12px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 14px;
		}
	}

	.list {
		position: relative;
		padding-bottom: 65px;

		.item {
			margin: 0 auto 10px;
			width: 355px;
			height: 88px;

			.img {
				position: absolute;
				width: 355px;
				height: 88px;
				z-index: 0;
			}

			.content-info {
				position: relative;
				width: 355px;
				height: 88px;
				display: flex;

				.dot {
					position: absolute;
					top: 0;
					left: 0;
					width: 49px;
					height: 18px;
					background: linear-gradient(124deg, #ff906d 0%, #ff3d45 100%);
					border-radius: 10px 0px 10px 0px;
					font-size: 11px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #ffffff;
					line-height: 18px;
					text-align: center;
				}

				.left {
					width: 85px;
					display: flex;
					flex-direction: column;
					flex-wrap: nowrap;
					align-content: center;
					justify-content: center;
					align-items: center;

					.price {
						font-size: 0;
						font-family: 'DINA';
						font-weight: bold;
						color: #ff4e4e;
					}

					.condition {
						height: 16px;
						font-size: 11px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #ff4e4e;
						line-height: 16px;
					}
				}

				.content {
					flex: 1;

					.name {
						box-sizing: border-box;
						padding-right: 15px;
						margin-top: 20px;
						width: 100%;
						height: 32px;
						font-size: 13px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						color: #333333;
						line-height: 16px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
					}

					.condition-time {
						display: flex;
						flex-direction: row;
						flex-wrap: nowrap;
						align-content: center;
						justify-content: center;
						align-items: center;
						margin-top: 6px;

						.condition {
							margin-right: 4px;
							height: 9px;
							font-size: 9px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #00754a;
							line-height: 9px;
							white-space: nowrap;
						}

						.time {
							width: 100%;
							height: 12px;
							font-size: 10px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #999999;
							line-height: 12px;
							white-space: nowrap;
						}
					}
				}

				.right {
					width: 87px;
					display: flex;
					align-content: center;
					align-items: center;
					justify-content: center;

					.btn {
						width: 64px;
						height: 26px;
						background: #00754a;
						border-radius: 6px;
						font-size: 12px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						color: #ffffff;
						line-height: 26px;
						text-align: center;
					}

					.img {
						width: 57px;
						height: 44px;
						position: absolute;
						top: 0;
						right: 0;
					}
				}
			}
		}
	}

	.mine-btn-box {
		width: 375px;
		height: 60px;
		position: fixed;
		bottom: 0;
		left: 0;
		background-color: #fff;
		z-index: 1;

		.mine-btn {
			margin: 10px auto 0;
			width: 355px;
			height: 40px;
			background: #00754a;
			border-radius: 10px;
			font-size: 15px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #ffffff;
			line-height: 40px;
			text-align: center;
		}
	}

}
</style>



// WEBPACK FOOTER //
// src/view/coupon/center.vue